export const introduction =
  'Teak (Tectona grandis), "Kungen av trädslag", är för utomhus- och marint bruk ett enastående material. Det finns många användningsområden för teak, men ytterst få alternativ. Teak har använts inom skeppsbyggnad och som konstruktionsmaterial i mer än 2000 år. Det finns exempel på indiska tempel med teakbjälkar som är mer än 1000 år som fortfarande är funktionella. Däcket på Titanic var av teak och har vid dykningar visat sig vara i samma goda skick som när hon sjönk 15 april 1912.'

export const advantages = {
  header: 'Fördelar',
  body:
    'Teak har förmåga att utveckla en silvergrå yta som ger såväl en vacker patina som ett fullgott skydd mot vädrets makter. Den är formstabilt och inte benäget att spricka, varför det kan lämnas ute eller i fuktiga miljöer utan ytbehandling. Med dess slitstyrka och naturliga, skyddande oljor har teak, förutom ett vackert utseende, även följande fördelar',
  bulletPoints: [
    'mycket lång livslängd',
    'litet eller inget underhållskrav',
    'motståndskraftighet mot fukt och (havs-)vatten',
    'UV-tålighet',
    'låg utvidgningskoefficient, varför träet är formstabilt i såväl värme som fukt och kyla',
    'hög kiselhalt, varför träet inte blir halt att gå på då blött',
    'korrosionsförhindrande egenskaper för järn',
  ],
}

export const origins = {
  header: 'Ursprung',
  body:
    'Vår teak härstammar från Burma (Myanmar), som står för ca 80% av exporten av naturlig teak i världen. Teak är inget regnskogsträd, utan växer glest i blandad lövskog. Normalt återfinns endast 1 till 5 träd per tunnland (~5000 kvm), men Burma etablerade förutseende nog teakplantager redan 1856 som svar på framtida efterfrågan. Plantagerna är noggrannt kontrollerade för dess stora ekologiska och ekonomiska betydelse. Teakplantor från Burma har även använts för att starta plantager i Afrika och Central Amerika. Många företag och privatpersoner har investerat i plantager i miljöhänseende och vinstintresse.',
}

export const deforestation = {
  header: 'Avverkning',
  body:
    'I Burma används fortfarande elefanter för transport av avverkat virke, då dessa har en betydligt mindre miljöpåverkan än tunga skogsmaskiner',
}
